import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'list',
  standalone: false,
})
export class ListPipe implements PipeTransform {
  constructor() {}

  transform(value: string[] | null | undefined): string | null | undefined;
  transform<T>(value: T[] | null | undefined, property: keyof T): string | null | undefined;
  transform<T>(
    value: T[] | null | undefined,
    property?: keyof T | null,
  ): string | null | undefined {
    const parts: any[] = [];

    if (value == null) {
      return '';
    }

    value
      .map(v => (property ? v[property] : v))
      .forEach((propertyValue, i) => {
        parts.push(propertyValue);

        // TODO: use locale
        if (i + 2 < value.length) {
          parts.push(', ');
        } else if (i + 1 < value.length) {
          parts.push(' and ');
        }
      });

    return parts.join('');
  }
}
